module.exports = __webpack_public_path__ + "img/robusta-bean.73f23f40.png";